<!--Checklist for the service provided-->
<ion-item
  lines="none"
  class="mb-checkbox"
>
  <ion-checkbox
    labelPlacement="end"
    justify="start"
    [(ngModel)]="service.selected"
    (ionChange)="toggleServiceSelection()"
  >
    <span class="checkbox-label ion-text-wrap ion-no-margin">
      {{ service?.name?.toLowerCase() }}
    </span>
  </ion-checkbox>
</ion-item>

<ion-button
  class="service-details"
  type="button"
  (click)="showServiceDetail()"
  size="small"
  fill="clear"
>
  <ion-icon
    *ngIf="service.isImportant"
    class="half-margin-end"
    name="shield-checkmark"
    color="grey-500"
    [attr.aria-label]="'show details for ' + service.name"
    slot="icon-only"
  >
  </ion-icon>

  <ion-icon
    name="information-circle"
    color="grey-300"
    [attr.aria-label]="'show details for ' + service.name"
    [slot]="!service.isImportant ? 'icon-only' : ''"
  >
  </ion-icon>
</ion-button>
